/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
export var EuiComboBoxTitle = ({
  children
}) => <div className="euiComboBoxTitle">{children}</div>;
EuiComboBoxTitle.propTypes = {};

try {
  // @ts-ignore
  EuiComboBoxTitle.displayName = "EuiComboBoxTitle"; // @ts-ignore

  EuiComboBoxTitle.__docgenInfo = {
    "description": "",
    "displayName": "EuiComboBoxTitle",
    "props": {}
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/combo_box/combo_box_options_list/combo_box_title.tsx#EuiComboBoxTitle"] = {
      docgenInfo: EuiComboBoxTitle.__docgenInfo,
      name: "EuiComboBoxTitle",
      path: "src/components/combo_box/combo_box_options_list/combo_box_title.tsx#EuiComboBoxTitle"
    };
} catch (__react_docgen_typescript_loader_error) {}